import axios from 'axios';

const userService = {
  async requestLogin(values) {
    return axios.post('/users/request-login', values);
  },
  async successLogin() {
    return axios.post('/users/success-login');
  },
  async validateToken(token, onSuccess, onError) {
    axios.post('/token/validate', token)
      .then((resp) => onSuccess(resp))
      .catch((error) => onError(error));
  },
  async selfInformation() {
    return axios.get('/users/self-information');
  },
  async getAvailableWorkstations() {
    return axios.get('/users/workstations/available');
  },
  async loginWorkstation(workstationId) {
    return axios.post(`/users/workstations/${workstationId}/login`);
  },
  async logout(workstationId) {
    const workstation = !workstationId || workstationId === null ? 0 : workstationId;
    return axios.put(`/users/workstations/${workstation}/logout`);
  }
};

export default userService;
